import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  fetchMusterApi,
  lockUnlockUserApi,
} from "../../api/musterAttendance.api";

export const fetchMuster = createAsyncThunk(
  "muster/fetchMuster",
  async (
    { month, year }: { month: number; year: number },
    { rejectWithValue }
  ) => {
    try {
      return await fetchMusterApi(month, year);
    } catch (err: any) {
      return rejectWithValue(err.message || "Failed to load muster data");
    }
  }
);

export const lockOrUnlockUser = createAsyncThunk(
  "muster/lockOrUnlockUser",
  async (
    { userId, lock }: { userId: string; lock: boolean },
    { rejectWithValue }
  ) => {
    try {
      await lockUnlockUserApi(userId, lock);
      return { userId, lock };
    } catch (err: any) {
      return rejectWithValue(err.message || "Failed to update lock field");
    }
  }
);

interface LockUserPayload {
  userId: string;
  lock: boolean;
}

interface MusterState {
  muster: any[];
  loading: boolean;
  error: string | null;
}

const initialState: MusterState = {
  muster: [],
  loading: false,
  error: null,
};

const musterSlice = createSlice({
  name: "muster",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMuster.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMuster.fulfilled, (state, action) => {
        state.loading = false;
        state.muster = action.payload;
      })
      .addCase(fetchMuster.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(lockOrUnlockUser.fulfilled, (state, action) => {
        const { userId, lock } = action.payload;
        const row = state.muster.find((r) => r.userId === userId);
        if (row) {
          row.isLockedFromApplying = lock;
        }
      });
  },
});

export default musterSlice.reducer;
